var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleClouds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.7516 31.7272H60.1908L67.1435 24.7745L67.4844 21.8216C54.5442 10.3987 34.7953 11.6327 23.3724 24.5729C20.1986 28.1645 17.8986 32.4426 16.6406 37.0714C17.4137 36.7544 18.2732 36.7016 19.0798 36.9273L32.9852 34.6322C32.9852 34.6322 33.691 33.4606 34.0607 33.5326C40.2451 26.7384 50.6549 25.9461 57.7996 31.7272H57.7516Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0602 37.0725C75.4613 31.1858 72.1818 25.8945 67.6203 21.8516L57.8635 31.6083C61.9833 34.9742 64.3313 40.0495 64.2304 45.3696V47.103C69.0272 47.103 72.9165 50.9923 72.9165 55.789C72.9165 60.5858 69.0272 64.4751 64.2304 64.4751H46.8584L45.125 66.2324V76.6518L46.8584 78.3852H64.2304C76.7049 78.4812 86.8986 68.446 86.9947 55.9715C87.0523 48.3946 83.3215 41.3075 77.0602 37.0725Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4568 78.2661H46.8288V64.3608H29.4568C28.218 64.3608 26.9984 64.0919 25.87 63.5781L23.4308 64.3368L16.4301 71.2894L15.8203 73.7286C19.7432 76.696 24.5352 78.2901 29.4568 78.2661Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4573 33.1643C16.978 33.2363 6.92836 43.4108 7.00038 55.8901C7.0436 62.8571 10.2943 69.4161 15.8209 73.6606L25.8945 63.587C21.5251 61.6135 19.5805 56.4662 21.5539 52.0968C23.5274 47.7274 28.6747 45.7828 33.0441 47.7562C34.9695 48.6253 36.5108 50.1714 37.3847 52.0968L47.4584 42.0231C43.1754 36.4149 36.5108 33.1354 29.4573 33.1643Z",
    fill: "#FBBC05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleClouds);
export default __webpack_public_path__ + "static/media/google-clouds.4ee74bf23e5785b33cb73c5b1104485c.svg";
export { ForwardRef as ReactComponent };